9<template>
  <DefaultLayout
    menuIndex="/company"
    openeds="attribution"
  >

    <div class="page-header">
      <el-button
        type="primary"
        @click="dialogFormVisible = true"
      >
        <el-icon color="#FFFFFF">
          <Plus />
        </el-icon>
      </el-button>
    </div>

    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      title="新增公司"
      width="500px"
    >
      <el-form
        :model="form"
        ref="form"
        :rules="rules"
      >
        <el-form-item
          label="公司名称"
          :label-width="formLabelWidth"
          prop="name"
        >
          <el-input
            v-model="form.name"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item
          label="上线时间"
          :label-width="formLabelWidth"
          prop="time"
        >
          <el-date-picker
            v-model="form.time"
            type="date"
            placeholder="请选择日期"
            :clearable="false"
          />
        </el-form-item>
        <el-form-item
          label="账号"
          :label-width="formLabelWidth"
          prop="username"
        >
          <el-input
            v-model="form.username"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item
          label="密码"
          :label-width="formLabelWidth"
          prop="password"
        >
          <el-input
            v-model="form.password"
            autocomplete="off"
            show-password
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="formCancel('form')">重置</el-button>
          <el-button
            type="primary"
            @click="formSubmit('form')"
          >确定</el-button>
        </span>
      </template>
    </el-dialog>

    <div style="padding: 20px">
      <el-table
        :data="tableData"
        style="width: 100%"
        border
      >
        <el-table-column
          label="#"
          type="index"
          width="50"
          :resizable="false"
        />
        <el-table-column
          prop="name"
          label="公司名称"
          width="150"
          :resizable="false"
        />
        <el-table-column
          prop="time"
          label="上线时间"
          width="150"
          :resizable="false"
        />
        <el-table-column
          prop="username"
          label="账号"
          width="180"
          :resizable="false"
        />
        <el-table-column
          prop="password"
          label="密码"
          :resizable="false"
        />
        <el-table-column
          fixed="right"
          label="操作"
          width="120"
          :resizable="false"
        >
          <template #default="scope">
            <el-button
              @click="openDelete(scope)"
              type="danger"
            >
              <el-icon>
                <Delete />
              </el-icon>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

  </DefaultLayout>
</template>

<script>
import DefaultLayout from '../components/layout/DefaultLayout.vue'
import { Companies } from '../api/request.js'
import moment from 'moment'
import { ElMessage, ElMessageBox } from 'element-plus'
import { WarningFilled } from '@element-plus/icons-vue';
import { markRaw } from 'vue';

export default {
  name: 'CompanyPage',
  components: {
    DefaultLayout,
  },
  methods: {
    getCompanyAccountInformation () {
      Companies.GetCompanyAccountInformation().then(res => {
        // console.log(res);
        let dataTem = [];
        for (let i = 0, len = res.length; i < len; i++) {
          dataTem.push({
            name: res[i].name,
            time: res[i].createTime === null ? '' : moment(res[i].createTime).format('YYYY-MM-DD'),
            username: res[i].loginName,
            password: res[i].password,
            id: res[i].id
          })
        }
        this.tableData = dataTem;
      })
    },
    formCancel (formName) {
      this.$refs[formName].resetFields();
    },
    formSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          Companies.AddCompanyAccountInformationn({
            name: this.form.name,
            loginName: this.form.username,
            password: this.form.password,
            createTime: moment(this.form.time).format('YYYY-MM-DD')
          }).then((res) => {
            // console.log(res);
            if (res === 'LoginName Already Exists') {
              ElMessage({
                showClose: true,
                message: '添加公司已存在',
                type: 'warning',
              })
            } else {
              ElMessage({
                showClose: true,
                message: '添加公司成功',
                type: 'success',
              })
              this.getCompanyAccountInformation();
            }
            this.dialogFormVisible = false
            this.$refs[formName].resetFields();
          })
        }
      })
    },
    openDelete (data) {
      // console.log(data.row.id);
      ElMessageBox.confirm(
        `<strong style="color: #F56C6C;">确定删除 ${data.row.name} 的信息?</strong>`,
        {
          type: 'error',
          showCancelButton: false,
          autofocus: false,
          confirmButtonClass: 'companyPage-delete-confirmButtonClass',
          dangerouslyUseHTMLString: true,
          icon: markRaw(WarningFilled),
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }
      ).then(() => {
        Companies.DeleteConfirmed(data.row.id).then((res) => {
          if (res === 'success') {
            ElMessage({
              showClose: true,
              type: 'success',
              message: '删除成功',
            })
            this.getCompanyAccountInformation();
          } else {
            ElMessage({
              showClose: true,
              type: 'error',
              message: '网络错误',
            })
          }
        })
      })
        .catch(() => {
          ElMessage({
            showClose: true,
            type: 'info',
            message: '取消删除',
          })
        })
    }
  },
  data () {
    return {
      dialogFormVisible: false,
      formLabelWidth: '80px',
      form: {
        name: '',
        time: new Date(),
        username: '',
        password: ''
      },
      tableData: [
        // {
        //     name: '知守科技',
        //     time: '2022-08-04',
        //     username: 'dusto',
        //     password: 'zhishou123'
        //     id: '1'
        // },
      ],
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
      },
    }
  },
  created () {
    this.getCompanyAccountInformation();
  }
}
</script>

<style>
.companyPage-delete-confirmButtonClass {
  background: #F56C6C !important;
  border: 0;
}
</style>

<style scoped>
.page-header {
  background-color: #F9F9F9;
  height: 60px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 20px;
}

.el-button--text {
  margin-right: 15px;
}

.el-select {
  width: 300px;
}

.el-input,
.el-date-editor.el-input {
  width: 300px;
}

.dialog-footer button:first-child {
  margin-right: 10px;
}

::v-deep .el-input,
.el-date-editor.el-input {
  width: 300px;
}
</style>
